//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../no/SelectBody.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CheckGeometryToggle",1,0],[0,"CheckOverlappingToggle",1,0],[0,"DefineStep",1,0],[0,"NoInteractionQueriesToggle",1,0],[0,"RenameComponentPartToggle",1,0],[1,"SelectProductBodies",0,"SelectBodyList",0],[1,"SelectSheetBodies",0,"SelectBodyList",0],[1,"SelectWorkpieceBody",0,"SelectBody",0],[0,"SewTolerance",1,0],[1,"SplittingSheets",0,"ScCollector",0],[0,"Type",1,0]],[[[],"SuppressPartingButton",{},0,0],[[],"InitBuilderData",{},0,0],[[],"UpdateBuilderData",{},0,0],[[],"SaveBuilderData",{},0,0],[[],"ResetBuilderData",{},0,0],[["allRegionUDOsSelected"],"SetAllRegionUdosSelected",{},1,0],[["regionNames"],"SetSelectedRegions",{},1,0],[[],"DeleteExistingSheets",{},0,0],[[],"PerformDisplayAndHighlight",{},0,0],[[],"TurnOffAllSheets",{},0,0],[["onOff"],"DisplayRegionOrSheetBody",{},1,0],[[],"PerformDisplayForTypeChange",{},0,0],[["regionName"],"CreateRegionSewnSheet",{},1,0],[["regionName"],"SuppressRegionSheet",{},1,0],[["viewPart"],"ReversePartNormal",{},1,0],[["displayedPart"],"SetDisplayedPart",{},1,0],[["workPart"],"SetWorkPart",{},1,0],[["regionName"],"CreateAssemblyNodeForRegionSheet",{R_:{linkedPart:"BasePart"}},1,0],[[],"AutoCreateSelectedSheets",{},0,0],[[],"RemoveCutSolidAttributeAfterSuppressParting",{},0,0]],[]];
SPLM.Tooling.MWDefineSheetsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.MWDefineSheetsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.MWDefineSheetsBuilder.Types = Object.freeze({
    "Region" : "Region", "SplitBody" : "SplitBody"});

SPLM.Tooling.MWDefineSheetsBuilder.DefineStepType = Object.freeze({
    "CutSolids" : "CutSolids", "CavityandCore" : "CavityandCore"});

export default SPLM;